/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&name=PeriodSwitch&setup=true&lang=js"
export * from "./index.vue?vue&type=script&name=PeriodSwitch&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=29343fd0&lang=scss"

const __exports__ = script;

export default __exports__